/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GrantResources} from '../models/GrantResources';

export interface GetProductGrantResources$Request {
    grantId: string;
    pageNumber: number;
    pageSize: number;
}

export interface GetProductGrantResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductGrantResourcesRequest = createAction<PayloadData<void, GetProductGrantResources$Request>>('PRODUCT_GRANT_RESOURCES__GET_PRODUCT_GRANT_RESOURCES__REQUEST');
export const getProductGrantResourcesSuccess = createAction<PayloadData<GrantResources, GetProductGrantResources$Request>>('PRODUCT_GRANT_RESOURCES__GET_PRODUCT_GRANT_RESOURCES__SUCCESS');
export const getProductGrantResourcesFailure = createAction<PayloadData<Error, GetProductGrantResources$Request, true>>('PRODUCT_GRANT_RESOURCES__GET_PRODUCT_GRANT_RESOURCES__FAILURE');

export const getProductGrantResourcesActions = [
    getProductGrantResourcesRequest,
    getProductGrantResourcesSuccess,
    getProductGrantResourcesFailure
] as const;

/**
 * @param {string} meta.grantId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductGrantResources = (meta: GetProductGrantResources$Request, config?: GetProductGrantResources$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getProductGrantResourcesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/entitlements/grants/${meta.grantId}/resources`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

